export default __webpack_public_path__ + "static/media/payment-success-woman.ed2f7ee6.webp";